<template>
  <Wrapper :type="type" @delete="$emit('delete')">
    <div :class="$style.videoWrapper" slot="preview">
      <iframe
        v-if="data.value"
        type="text/html"
        width="560"
        height="349"
        :src="`https://www.youtube.com/embed/${youtubeVideoId}`"
        frameborder="0"
      />
    </div>
    <v-text-field
      slot="edition"
      :value="data.value"
      label="YouTube video link"
      :rules="[formRules.required, formRules.YT]"
      box
      @input="setValue"
    ></v-text-field>
  </Wrapper>
</template>

<script>
import Wrapper from "../../components/widgets/Wrapper";

export default {
  name: "Player",
  components: {
    Wrapper
  },
  model: {
    prop: "data"
  },
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    youtubeVideoId() {
      return this.data.value.substr(-11);
    }
  },
  methods: {
    setValue(value) {
      this.$emit("input", {
        value
      });
    }
  }
};
</script>

<style lang="sass" module>
.videoWrapper
  position: relative
  padding-bottom: 56.25%
  padding-top: 25px
  height: 0
  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
</style>
